import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStoreClubAuth } from '../contexts/StoreClubAuthContext';

interface StoreClubProtectedRouteProps {
  children: React.ReactNode;
}

const StoreClubProtectedRoute: React.FC<StoreClubProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useStoreClubAuth();

  if (isLoading) {
    return (
      <div style={styles.loading}>
        <div style={styles.spinner}></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/club" replace />;
  }

  return <>{children}</>;
};

const styles: { [key: string]: React.CSSProperties } = {
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
    color: '#508590',
    fontSize: '1.2rem',
    gap: '1rem',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #e0e0e0',
    borderTop: '4px solid #508590',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};

export default StoreClubProtectedRoute;
